import { useAppSetting } from '../useAppSettings'
import { jsonTryParse } from '@ztechapps/common.utils'
import isEmpty from 'lodash/isEmpty'
import type { QzOption } from './useQz'
import { useMemo } from 'react'

export const useQzOptions = (): QzOption[] => {
  const { setting } = useAppSetting({ appSettingKey: 'QZ_TRAY_OPTIONS' })
  const value = setting?.value

  //this includes the certificate, signature, host in array value
  return useMemo(() => {
    const parsedValue = jsonTryParse(value)

    return isEmpty(parsedValue) ? [] : (parsedValue as QzOption[])
  }, [value])
}
